import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AttachmentUploadError = /*#__PURE__*/function (_Error) {
  function AttachmentUploadError(code, message) {
    var _this;
    _classCallCheck(this, AttachmentUploadError);
    _this = _callSuper(this, AttachmentUploadError, [message]);
    _defineProperty(_this, "code", void 0);
    _this.name = 'AttachmentUploadError';
    _this.code = code;
    return _this;
  }
  _inherits(AttachmentUploadError, _Error);
  return _createClass(AttachmentUploadError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export default AttachmentUploadError;
export var FILE_NOT_ACCEPTED = 'file_not_accepted';
export var FILE_TYPE_NOT_ALLOWED = 'file_type_not_allowed';
export var FILE_SIZE_EXCEEDED = 'file_size_exceeded';
export var ERROR_GENERIC = 'error_generic';